import styled from 'styled-components';

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;

  button {
    width: 100%;
  }
`;

export const ForgotPasswordContainer = styled.div`
  margin-top: 8px;
`;
